import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { TextField } from "./fields.js";

export class Greffe extends TextField {
	static properties = {
		target : {type : String}
	};
	
	constructor (){
		super ();
		this.target = "greffe_mention";
	}
	
	render (){
		return html`
			<div class="row align-items-center">
				<label for="${this.idInput}" class="col-sm-3 col-form-label text-end">${this.label}</label>
				<div class="col-sm-9">
					<input
						id="${this.idInput}"
						type="text"
						placeholder="${this.placeholder}"
						value="${this.value}"
						name="${this.name}"
						data-input ?required=${this.required}
						autocomplete="${this.disableAutocomplete ? 'off' : 'on'}"
						@input="${this.handleInput}"
						@change="${this.handleChange}"
						/>
				</div>
			</div>
		`;
	}
	
	handleChange (){
		const targetNode = $("[name=" + this.target + "]") [0];
		if (!targetNode)
			return;
		
		const ancienGreffe = "old_greffe";		
		const ancienGreffeNode = $("[name=" + ancienGreffe + "]") [0];
		
		targetNode.value = targetNode.placeholder
			.replace ("[greffe]", this.value)
			.replace ("[Nouveau greffe]", this.value);
			
		if (ancienGreffeNode && ancienGreffeNode.value)
			targetNode.value = targetNode.value
				.replace ("[Ancien greffe]", ancienGreffeNode.value);
	}
}

customElements.define ("greffe-field", Greffe);
